import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/config/queryClient';
import { router } from '@/routes';
import { Loading } from '@/components/common';
import { LocalSessionGuard } from '@/components/LocalSessionGuard';

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center">
            <Loading size="lg" text="加载中..." />
          </div>
        }
      >
        <LocalSessionGuard><RouterProvider router={router} /></LocalSessionGuard>
      </Suspense>
    </QueryClientProvider>
  );
};

export default App;
